<template>
  <v-dialog max-width="630" v-bind="$attrs" v-on="$listeners">
    <v-card class="modal">
      <v-btn class="close-button" icon aria-label="close" @click="closeModal">
        <v-icon>
          close
        </v-icon>
      </v-btn>
      <div class="content">
        <h1 class="heading mr-6">
          Change the status of this application for {{ clientName }}
            ?
        </h1>
        <div class="mt-4">
          <ApplicationStatusChip small :status="status" />
        </div>
        <div class="mt-4">
          <AdsTextField v-if="isRequestApprovalStatus" 
            label="Approver Email"
            v-model="approverEmail"
            maxlength="100"
            hide-details
            required
          />
        </div>
        <div>
          <AdsTextArea
            ref="comment"
            v-model="comment"
            label="Comments (office use only - optional)"
            placeholder=" "
            rows="5"
            :counter="counter"
            :maxlength="counter"
            :readonly=false
          />
        </div>
        <SupportingDocumentUpload 
          v-model="files"
          ref="supportingDocumentUpload"
          :is-busy.sync="isFileOperationInProgress"
        />
      </div>
      <div class="d-flex justify-end pt-3">
        <v-btn
          class="px-6 py-4 confirmButton"
          @click="confirmChange"
          :color="confirmButtonColour"
          min-width="50%"
          :disabled="!isValid || isFileOperationInProgress"
          data-testid="confirmButton"
        >
          Confirm status change
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import  AdsTextField from '@/components/app/AdsTextField.vue'
import  AdsTextArea  from '@/components/app/AdsTextArea.vue'
import { EA_STATUS } from '@/constants'
import SupportingDocumentUpload from '@/components/app/SupportingDocumentUpload'
import fieldHelperMixin from '@/helpers/fieldHelperMixin'
import ApplicationStatusChip from '@/components/application/ApplicationStatusChip.vue'


export default {
  name: 'ChangeStatusModal',
  mixins: [fieldHelperMixin],  
  components: {
    AdsTextArea,
    SupportingDocumentUpload,
    ApplicationStatusChip,
    AdsTextField
  },
  props: {
   clientName: {
      type: String
    },
    currentStatus: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      comment: '',
      approverEmail: '',
      sendEmail: this.getDefaultSendEmailFlag(),
      counter: 200,
      files: [],
      isFileOperationInProgress: false
    }
  },
  methods: {
    confirmChange() {
      this.$emit('confirm', {
        status: this.status,
        comment: this.comment.trim(),
        sendEmail: [EA_STATUS.INFO_REQ , EA_STATUS.APPROVAL_REQ].includes(this.status),
        approverEmail :'',
        documents: this.files
      })
      this.$emit('input', false)
    },
    getDefaultSendEmailFlag() {
      return (
        [EA_STATUS.INFO_REQ , EA_STATUS.APPROVAL_REQ].includes(this.status)
      )
    },
    resetDefaultSendEmailFlag() {
      this.sendEmail = this.getDefaultSendEmailFlag()
    },
    closeModal() {
      if (this.files) {
        this.$refs.supportingDocumentUpload.deleteAll()
      }
      this.$emit('input', false)
    }
  },
  computed: {
    isValid() {
      console.log(this.status)
      return this.status 
    },
    isRequestApprovalStatus() {
        return EA_STATUS[this.status] == EA_STATUS.APPROVAL_REQ
    },
    emailLabel() {
      const labelByStatus = {
        [EA_STATUS.APPROVAL_REQ]: `Email Approver to review and Approve this `,
        [EA_STATUS.INFO_REQ]: `Email Client to Provide more information`,
        
      }

      return labelByStatus[this.status]
    },
    confirmButtonColour() {
      if (this.status === EA_STATUS.DECLINED_POST_APPEAL) {
        return 'red'
      }
      return this.options ? this.options.buttonColor : ''
    },
    emailTemplateUri() {
      return this.$store.getters.emailTemplateLink
    }
  }
}
</script>

<style scoped lang="scss">
.modal {
  padding: 2rem;
  .v-btn {
    &.red:focus {
      box-shadow: 0 0 0 4px $color-red-border;
    }
    &.green:focus {
      box-shadow: 0 0 0 4px #ccefce;
    }
    &.confirmButton {
      color: #ffffff;
    }
  }
  .v-text-field.v-textarea {
    margin-left: 0;
  }
}

.heading {
  font-size: 1.333333rem;
  color: $color-primary;
}

.body {
  margin: 3.5rem 0;
}

.close-button {
  position: absolute;
  top: 0.15rem;
  right: 0.15rem;
  border: none;
}

.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: $ads-dark-60 !important;
  color: $ads-white !important;
}

::v-deep .email-checkbox-container {
  background-color: $ads-light-10;
  border-radius: 4px;
  .theme--light.v-label {
    color: $ads-dark;
  }
}
</style>
